import { env } from '@config/env';
import * as Sentry from '@sentry/react';

/**
 * Inicializa o Sentry quando `VITE_SENTRY_DSN` está definido (RNF-15).
 * Sem DSN (dev/local), é um no-op silencioso.
 */
export function initSentry(): void {
  if (!env.VITE_SENTRY_DSN) return;

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    integrations: [Sentry.browserTracingIntegration()],
  });
}

export { Sentry };
